import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@material-ui/core/Button";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import DoneIcon from "@mui/icons-material/Done";
import DangerousIcon from "@mui/icons-material/Dangerous";
import Box from "@mui/material/Box";
import Config from "conFig.js";
import NotificationsIcon from "@mui/icons-material/Notifications";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const rolecolumns = [
  {
    field: "rolE_ID",
    headerName: "ROLE ID",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "rolE_NAME",
    headerName: "ROLE NAME",
    width: 200,
    headerAlign: "center",
  },
];
const phanquyendbcolumn = [
  { field: "id", headerName: "id", width: 100 },
  {
    field: "value",
    headerName: "Tên Dashboard",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "moTa",
    headerName: "Mô tả",
    width: 300,
    headerAlign: "center",
  },
];

export default function PhanQuyenDashboard() {
  const [selectedroleRows, setSelectedroleRows] = React.useState([]);
  const [selecteddbRows, setSelecteddbRows] = React.useState([]);
  const [roles, setRoles] = React.useState([]);
  const [dashboard, setDashboard] = React.useState([]);
  const init = [];
  const [initdashboard, setInitdashboard] = React.useState([]);
  const [alert, setAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [icon, setIcon] = React.useState(AddAlert);
  const [color, setColor] = React.useState("warning");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const getroles = () => {
    var url = Config.backend + "/api/roles/roles";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setRoles(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdashboard = () => {
    var url = Config.backend + "/api/DashBoard/get_dashboard";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setDashboard(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdashboardbyrole = (showMs) => {
    if (selectedroleRows.length == 1) {
      var role = selectedroleRows[0].rolE_ID;
      var url = Config.backend + "/api/DashBoard/Getdashbyrole?V_Role=" + role;
      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          if (data.length !== 0) {
            data.map((prop) => {
              init.push(prop.id);
            });
            setInitdashboard(init);
          } else {
            setInitdashboard([]);
          }
          if (showMs) {
            showNotification(
              "Role " + role + " có " + data.length + " menu",
              NotificationsIcon,
              "success"
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const showNotification = (ms, icon, color) => {
    setAlert(true);
    setMessage(ms);
    setIcon(icon);
    setColor(color);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };
  const capnhat = () => {
    if (selectedroleRows.length == 1) {
      var kq = [];
      selecteddbRows.map((prop) => {
        kq.push({ id: prop.id });
      });
      let url = Config.backend + "/api/DashBoard/capnhatroledashboard";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          rolE_ID: selectedroleRows[0].rolE_ID,
          dashboarD_id: kq,
          username: username,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response;
          }
          throw new Error("Something went wrong");
        })
        .then(() => {
          showNotification("Cập nhật thành công", DoneIcon, "success");
          getdashboardbyrole(false);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
          showNotification("Cập nhật thất bại", DangerousIcon, "danger");
        });
    } else {
      showNotification("Vui lòng chọn Role", AddAlert, "warning");
    }
  };
  React.useEffect(() => {
    getdashboardbyrole(true);
  }, [selectedroleRows]);
  React.useEffect(() => {
    getroles();
    getdashboard();
  }, []);
  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={10}
        md={12}
        style={{ marginTop: 10, marginBottom: 10 }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={capnhat}
          style={{ height: 30 }}
        >
          Cập nhật
        </Button>
      </GridItem>
      <GridItem xs={12} sm={10} md={4}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.rolE_ID}
            rows={roles}
            columns={rolecolumns}
            rowsPerPageOptions={[]}
            hideFooter={true}
            checkboxSelection={false}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = roles.filter((row) =>
                selectedIDs.has(row.rolE_ID)
              );
              setSelectedroleRows(selectedRows);
            }}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={8}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={dashboard}
            columns={phanquyendbcolumn}
            rowsPerPageOptions={[]}
            hideFooter={true}
            selectionModel={initdashboard}
            checkboxSelection
            onSelectionModelChange={(ids) => {
              setInitdashboard(ids);
              const selectedIDs = new Set(ids);
              const selectedRows = dashboard.filter((row) =>
                selectedIDs.has(row.id)
              );
              setSelecteddbRows(selectedRows);
            }}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={12} md={10} lg={8}>
        <Snackbar
          place="tc"
          color={color}
          icon={icon}
          message={message}
          open={alert}
          closeNotification={() => setAlert(false)}
          close
        />
      </GridItem>
    </GridContainer>
  );
}
